var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHome48Line = function SvgIconHome48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.71 17.97-9.4-7.51a5.267 5.267 0 0 0-6.62 0l-9.4 7.51a5.256 5.256 0 0 0-1.99 4.14V33.4c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V22.11c0-1.62-.73-3.13-1.99-4.14ZM22.2 35.3v-5.6h3.6v5.6h-3.6Zm13.1-1.9a1.9 1.9 0 0 1-1.9 1.9h-4.2v-6.1c0-1.6-1.3-2.9-2.9-2.9h-4.6c-1.6 0-2.9 1.3-2.9 2.9v6.1h-4.2a1.9 1.9 0 0 1-1.9-1.9V22.11c0-.58.26-1.12.71-1.48l9.4-7.51a1.9 1.9 0 0 1 2.38 0l9.4 7.51c.45.36.71.9.71 1.48V33.4Z",
    fill: "current"
  })));
};
export default SvgIconHome48Line;